import {Controller} from "@hotwired/stimulus"

class DashboardDueQuizzesController extends Controller {
  connect() {
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        // Check if new child nodes were added.
        if (mutation.addedNodes.length > 0) {
          this.calculateMaxHeight()
        }
      })
    })
    this.observer.observe(this.element, {childList: true})
    this.calculateMaxHeight()
    window.addEventListener("turbo:submit-start", this.disableOtherForms)
    window.addEventListener("turbo:submit-end",   this.enableAllForms)
  }

  disconnect() {
    this.observer.disconnect()
    window.removeEventListener("turbo:submit-start", this.disableOtherForms)
    window.removeEventListener("turbo:submit-end",   this.enableAllForms)
  }

  calculateMaxHeight() {
    let totalHeight = 0;
    // Loop through the first 3 children and add their heights
    for (let i = 0; i < 3; i++) {
      const child = this.element.children[i]
      if (child) totalHeight += child.offsetHeight
    }
    this.element.style.maxHeight = `${totalHeight - 1}px`;
  }

  disableOtherForms = (event) => {
    const submittingForm = event.target
    this.forms().forEach(form => {
      if (form !== submittingForm) {
        this.toggleForm(form, true)
      }
    })
  }

  enableAllForms = () => {
    this.forms().forEach(form => this.toggleForm(form, false))
  }

  forms() {
    return this.element.querySelectorAll("form")
  }

  toggleForm(form, disabled) {
    form.querySelectorAll("button").forEach(el => {
      el.disabled = disabled
    })
  }
}
export default DashboardDueQuizzesController
